import { NewSession } from '../../state/session/session.actions';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Component, inject, OnInit } from '@angular/core';
import { ResetScans } from '../../state/scanner/scanner.actions';
import { pluck } from 'rxjs/operators';
import { IDocumentResult } from '../../state/interfaces';
import { AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatCard } from '@angular/material/card';
import { AlertBoxComponent } from '../shared/alert-box/alert-box.component';
import { MatButton } from '@angular/material/button';
import { ThrottleClickDirective } from '@drc-eca/eca-lrc-common-ui';

@Component({
  selector: 'eca-scoring-results',
  templateUrl: './scoring-results.component.html',
  styleUrls: ['./scoring-results.component.css'],
  imports: [MatProgressSpinner, MatCard, AlertBoxComponent, MatButton, ThrottleClickDirective, AsyncPipe]
})
export class ScoringResultsComponent implements OnInit {
  private store = inject<Store<any>>(Store);
  private router = inject(Router);


  scoringStatus$: Observable<string>;
  results$: Observable<IDocumentResult[]>;

  ngOnInit() {
    this.scoringStatus$ = this.store.select('scans').pipe(pluck('scoringStatus'));
    this.results$ = this.store.select('results');
  }

  backToScanning() {
    this.store.dispatch(new NewSession());
    this.store.dispatch(new ResetScans());
    this.router.navigate(['/scan']);
  }
}
